 export enum TypeRegleSequenceCalculEnum {
Constante = 1,
VariableDynamique = 2,
Rubrique = 3,
RubriqueBulletin = 4,
RubriqueBulletinElementVariable = 5,
RubriqueQualification = 6,
RubriqueGenerale = 7,
Fonction = 8,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeRegleSequenceCalculEnum.ts